module.exports = __webpack_public_path__ + "img/seo.4a3d1e5.svg";